<template>
  <ClicColInterno alignSelf="end" :cp="cp" :key="componentKey">

    <b-row>
      <b-col :md="mdColumnList" v-if="showList">
        <b-card class="clic-calendar-list-card">
          <b-card-header class="text-center clic-calendar-list-title">
            <h5 class="mb-0">Próximos Eventos</h5>
          </b-card-header>
          <b-card-body>
            <b-input-group class="mb-1">
              <b-form-input v-model="searchQuery" placeholder="Pesquisar eventos"></b-form-input>
              <b-input-group-append>
                <b-button id="ocultar-concluidos-btn" :variant="disableCompletedEvents ? 'primary' : 'outline-primary'"
                  @click="handleDisableCompleted()">
                  {{ messageDisabledCompletedEvents }}
                </b-button>
                <b-tooltip target="ocultar-concluidos-btn"
                  title="Clique para ocultar ou mostrar eventos concluídos"></b-tooltip>
                <b-button id="novo-evento-btn" variant="primary" @click="defineInputsModalCreate(new Date())">
                  <ClicIconInterno iconName="bi-plus" iconTitle="Mais" />
                  Novo
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <div v-for="(events, day) in paginatedEvents" :key="day" class="clic-calendar-day-group">
              <div class="clic-calendar-day-header d-flex justify-content-between align-items-center">
                <span class="clic-calendar-day-date">{{ formatDateForList(day) }}</span>
                <span class="clic-calendar-day-weekday">{{ formatDayOfWeek(day) }}</span>
              </div>
              <b-list-group flush>
                <b-list-group-item v-for="event in events" :key="event._id" @click="defineInputsModalEdit(event)"
                  class="clic-calendar-event-item d-flex align-items-center">
                  <span class="clic-calendar-event-accent" :class="event.class"></span>
                  <span class="clic-calendar-event-icon">
                    <ClicIconInterno :iconName="getSituationIcon(event.situacao.value)" :title="event.situacao.text" />
                  </span>
                  <span class="clic-calendar-event-title">{{ event.title }}</span>
                  <span class="clic-calendar-event-times">
                    <span class="clic-calendar-event-time">{{ formatTimeForList(event.start) }}</span>
                    <span class="clic-calendar-event-sep">→</span>
                    <span class="clic-calendar-event-time">{{ formatTimeForList(event.end, event.start) }}</span>
                  </span>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div class="d-flex justify-content-center mt-3">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="registerPerPageList"
                aria-controls="my-table"></b-pagination>
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col v-if="!hideCalendar">
        <vue-cal ref="vuecal" :activeView="activeView" :allDayBarHeight="allDayBarHeight" :cellClickHold="cellClickHold"
          :cellContextmenu="cellContextmenu" :clickToNavigate="clickToNavigate" :dblclickToNavigate="dblclickToNavigate"
          :disableDatePrototypes="disableDatePrototypes" :disableDays="disableDays" :disableViews="disableViews"
          :dragToCreateEvent="dragToCreateEvent" :dragToCreateThreshold="dragToCreateThreshold" :editableEvents="false"
          :events="events" :eventsCountOnYearView="eventsCountOnYearView" :eventsOnMonthView="eventsOnMonthView"
          :hideBody="hideBody" :hideTitleBar="hideTitleBar" :hideViewSelector="hideViewSelector"
          :hideWeekdays="hideWeekdays" :hideWeekends="hideWeekends" :locale="locale" :maxDate="maxDate"
          :minCellWidth="minCellWidth" :minDate="minDate" :minEventWidth="minEventWidth" :minSplitWidth="minSplitWidth"
          :overlapsPerTimeStep="overlapsPerTimeStep" :resizeX="resizeX" :selectedDate="selectedDate"
          :showAllDayEvents="showAllDayEvents" :showTimeInCells="showTimeInCells" :showWeekNumbers="showWeekNumbers"
          :small="small" :snapToTime="snapToTime" :specialHours="specialHours" :splitDays="splitDays"
          :startWeekOnSunday="startWeekOnSunday" :stickySplitLabels="stickySplitLabels" :time="time"
          :timeCellHeight="timeCellHeight" :timeFormat="timeFormat" :timeFrom="timeFrom" :timeStep="timeStep"
          :timeTo="timeTo" :todayButton="todayButton" :transitions="transitions" :twelveHour="twelveHour"
          :xsmall="xsmall" :watchRealTime="watchRealTime" :class="this.class" :style="this.style"
          @cell-click="onEventClick" @cell-dblclick="onEventDblclick" @event-delete="onEventDelete"
          @event-focus="onEventFocus" @view-change="onViewChange">

          <template v-if="showEventIcon" #event="{ event }">
            <ClicIconInterno :iconName="getSituationIcon(event.situacao.value)" />

          </template>

        </vue-cal>
      </b-col>
    </b-row>

    <b-modal id="create-event-modal" size="lg" :title="isEditingEvent == true ? 'Editar Evento' : 'Criar Evento'"
      footer-class="clic-calendar-modal-footer">
      <b-row>
        <b-col>
          <template>
            <div>
              <b-row>
                <b-col md="3">
                  <label class="mb-0" for="event-title">Título</label>
                  <b-form-input id='event-title' v-model="selectedEvent.title" placeholder="Título"
                    class="mb-2"></b-form-input>
                </b-col>
                <b-col md="4" >
                  <label class="mb-0" for="group-class">Estilo</label>
                  <b-input-group id='group-class' style="flex-wrap: nowrap !important;">
                    <b-input-group-prepend is-text>
                      <div class="color-block" :class="selectedEvent.class"></div>
                    </b-input-group-prepend>
                    <b-form-select id='event-class' v-model="selectedEvent.class" :options="colorOptions">
                    </b-form-select>
                  </b-input-group>
                </b-col>
                <b-col md="4" class="mx-2">
                  <div v-if="enableRecurrence" v-show="!isEditingEvent">
                    <label class="mb-0 d-block" for="event-recorrencia">Recorrência</label>
                    <b-form-checkbox id="event-recorrencia" v-model="isRecurrent" class="mt-1">
                      Ativa
                    </b-form-checkbox>
                  </div>
                  <div v-show="isEditingEvent" >
                    <label class="mb-0" for="event-situacao">Situação</label>
                    <multiselect disabled id='event-situacao' v-model="selectedEvent.situacao"
                      :placeholder="'Selecione'" label="text" :options="situations" :multiple="false">
                    </multiselect>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div>
              <b-row>
                <b-col md="7">
                  <label class="mb-0" for="event-startDate">Data Inicio</label>
                  <b-form-datepicker id="event-startDate" v-model="selectedEvent.startDate" :locale="this.getLocale()"
                    class="mb-2">
                  </b-form-datepicker>
                </b-col>
                <b-col>
                  <label class="mb-0" for="event-startTime">Hora Início</label>
                  <b-form-timepicker id="event-startTime" v-model="selectedEvent.startTime" locale="de"
                    minutes-step="5">
                  </b-form-timepicker>
                </b-col>
              </b-row>
            </div>
            <div>
              <b-row>
                <b-col md="7">
                  <label class="mb-0" for="event-endDate">Data fim</label>
                  <b-form-datepicker id="event-endDate" v-model="selectedEvent.endDate" :locale="this.getLocale()"
                    class="mb-2"></b-form-datepicker>
                </b-col>
                <b-col>
                  <label class="mb-0" for="event-endTime">Hora Fim</label>
                  <b-form-timepicker id="event-endTime" v-model="selectedEvent.endTime" locale="de"
                    minutes-step="5"></b-form-timepicker>
                </b-col>
              </b-row>
            </div>
            <div v-if="enableRecurrence && isRecurrent">
              <b-row class="mt-2">
                <b-col md="2">
                  <label class="mb-0">Repetir</label>
                  <b-form-input id='event-recurrent-period' v-model="recurrentConfig.period" class="mb-2"
                    type="number"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label class="mb-0" for="event-recurrent-period"> a cada:</label>
                  <multiselect id='event-recurrent-period' v-model="recurrentConfig.interval" :placeholder="'Selecione'"
                    label="text" :options="recurrentIntervals" :multiple="false">
                  </multiselect>
                </b-col>
                <b-col>
                  <label class="mb-0" for="event-recurrent-endDate">Fim da Repetição</label>
                  <b-form-datepicker id="event-recurrent-endDate" v-model="recurrentConfig.endDate"
                    :locale="this.getLocale()" class="mb-2"></b-form-datepicker>
                </b-col>
              </b-row>
            </div>
            <b-row class="mt-2">
              <b-col>
                <label class="mb-0" for="event-observation">Observação</label>
                <b-form-textarea id="event-observation" v-model="selectedEvent.observation"
                  placeholder="Adicione suas observações aqui" rows="2"></b-form-textarea>
              </b-col>
            </b-row>
          </template>

          <template v-if="getSlotModal()">
            <MotorS :cp="cp" :childrens="getSlotModal()" :idTela="idTela" :state="state" />
          </template>

        </b-col>
        <b-col md="5" v-if="showModalCalendar">
          <vue-cal :events="events" :selected-date="selectedEvent.startDate" view="day" style="height: 400px"
            :hide-view-selector="true" :disable-views="['years', 'year', 'month', 'week']" :locale="locale">
          </vue-cal>
        </b-col>


      </b-row>

      <template v-slot:modal-footer>

        <template v-if="getSlotAcao() && !situationsOfConcludedEvents.includes(getSelectedEventSituation())">
          <MotorS :cp="cp" :childrens="getSlotAcao()" :idTela="idTela" :state="state" />
        </template>

        <template v-if="showEventActions && !enableRecurrence">
          <b-button variant="outline-danger" @click="$bvModal.show('delete-event-modal')">
            Excluir
          </b-button>
          <b-button variant="outline-secondary" @click="defineObjectEditEvent('single')">
            Salvar
          </b-button>
        </template>

        <template v-if="showEventActions && enableRecurrence">
          <b-dropdown variant="outline-danger">
            <template v-slot:button-content>
              Excluir Evento
              <ClicIconInterno iconName="md-keyboardarrowdown" iconTitle="Opções" />
            </template>
            <b-dropdown-item @click="$bvModal.show('delete-event-modal')">
              Excluir este evento
            </b-dropdown-item>
            <b-dropdown-item v-if="selectedEvent.recurrentId" @click="$bvModal.show('delete-recurrents-modal')">
              Excluir este evento e suas recorrências
            </b-dropdown-item>
            <b-dropdown-item v-if="selectedEvent.recurrentId" @click="$bvModal.show('delete-following-modal')">
              Excluir este evento e os eventos seguintes
            </b-dropdown-item>
          </b-dropdown>

          <b-dropdown variant="outline-secondary">
            <template v-slot:button-content>
              Editar Evento
              <ClicIconInterno iconName="md-keyboardarrowdown" iconTitle="Opções" />
            </template>
            <b-dropdown-item @click="defineObjectEditEvent('single')">
              Editar este evento
            </b-dropdown-item>
            <b-dropdown-item v-if="selectedEvent.recurrentId" @click="$bvModal.show('edit-serie-modal')">
              Editar este evento e suas recorrências
            </b-dropdown-item>
            <b-dropdown-item v-if="selectedEvent.recurrentId" @click="$bvModal.show('edit-following-modal')">
              Editar este evento e os eventos seguintes
            </b-dropdown-item>
          </b-dropdown>

          <b-button v-if="selectedEvent.recurrentId" variant="outline-primary" @click="defineInputsModalRecurrent()">
            Editar Recorrência
          </b-button>
        </template>

        <b-button v-if="!isEditingEvent" variant="outline-secondary" @click="defineObjectCreateEvent()">
          Criar Evento
        </b-button>

        <b-button variant="light" @click="hideModalsClearVariables()">
          Fechar
        </b-button>

      </template>
    </b-modal>


    <b-modal id="delete-event-modal" size="s" title="Excluir Evento">
      <template>
        <p>Deseja realmente excluir o evento?</p>
      </template>
      <template v-slot:modal-footer>
        <b-button variant="outline-danger" style="border: none" @click="defineObjectDeleteEvent('single')">Excluir</b-button>
        <b-button variant="secondary" @click="$bvModal.hide('delete-event-modal')">Cancelar</b-button>
      </template>
    </b-modal>

    <b-modal id="delete-recurrents-modal" size="s" title="Excluir todas as recorrências">
      <template>
        <p>Deseja realmente excluir o evento e suas recorrências?</p>
      </template>
      <template v-slot:modal-footer>
        <b-button variant="outline-danger" style="border: none" @click="defineObjectDeleteEvent('serie')">
          Excluir Recorrências
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('delete-event-modal')">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="delete-following-modal" size="s" title="Excluir todas as recorrências">
      <template>
        <p>Deseja realmente excluir o evento e suas recorrências seguintes?</p>
      </template>
      <template v-slot:modal-footer>
        <b-button variant="outline-danger" style="border: none" @click="defineObjectDeleteEvent('following')">
          Excluir Recorrências
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('delete-following-modal')">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="edit-serie-modal" size="s" title="Editar todas as recorrências">
      <template>
        <p>Deseja realmente editar o evento e suas recorrências? </p>
        <p>Todas as informações com exceção da data serão sobrescrevidas.</p>
      </template>
      <template v-slot:modal-footer>
        <b-button variant="outline-primary" style="border: none" @click="defineObjectEditEvent('serie')">
          Editar Recorrências
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('edit-serie-modal')">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="edit-following-modal" size="s" title="Editar evento e os eventos seguintes">
      <template>
        <p>Deseja realmente editar o evento e suas recorrências seguintes? </p>
        <p>Todas as informações com exceção da data serão sobrescrevidas.</p>
      </template>
      <template v-slot:modal-footer>
        <b-button  variant="outline-primary" style="border: none" @click="defineObjectEditEvent('following')">
          Editar Recorrências</b-button>
        <b-button variant="secondary" @click="$bvModal.hide('edit-serie-modal')">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="edit-recurrent-modal" size="s" title="Editar a recorrência">
      <template>
        <p>Ao alterar a recorrência novos eventos serão gerados. Campos personalizados sofrerão alteração.
        </p>
        <b-row class="mt-2">
          <b-col>
            <label class="mb-2" for="recurrent-endDate">Novo inicio da repetição:</label>
            <b-form-datepicker id="recurrent-endDate" v-model="recurrentConfig.newStartDate" :locale="this.getLocale()"
              class="mb-2">
            </b-form-datepicker>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="2">
            <label class="mb-0">Repetir</label>
            <b-form-input id='event-recurrent-period' v-model="recurrentConfig.period" class="mb-2"
              type="number"></b-form-input>
          </b-col>
          <b-col md="3">
            <label class="mb-0" for="event-recurrent-period"> a cada:</label>
            <multiselect id='event-recurrent-period' v-model="recurrentConfig.interval" :placeholder="'Selecione'"
              label="text" :options="recurrentIntervals" :multiple="false">
            </multiselect>
          </b-col>
          <b-col>
            <label class="mb-0" for="event-recurrent-endDate">Fim da Repetição</label>
            <b-form-datepicker id="event-recurrent-endDate" v-model="recurrentConfig.newEndDate"
              :locale="this.getLocale()" class="mb-2"></b-form-datepicker>
          </b-col>
        </b-row>
      </template>
      <template v-slot:modal-footer>
        <b-button  variant="outline-primary" style="border: none" @click="defineObjectEditRecurrent()">
          Editar Recorrência
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('edit-serie-modal')">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="lost-sell-modal" size="s" title="Marcar como Perda">
      <template>
        <p>Selecione o motivo da perda</p>
        <b-row class="mt-1">
          <multiselect id='event-situacao-perda' v-model="selectedReasonForLoss" :placeholder="'Selecione'" label="text"
            :options="reasonsForLoss" :multiple="false">
          </multiselect>
        </b-row>
      </template>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="confirmarPerda()">
          Marcar como perda
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('lost-sell-modal')">
          Cancelar
        </b-button>
      </template>
    </b-modal>

  </ClicColInterno>
</template>
<script>

import ComponentMixin from '../../core/ComponentMixin';
import VueCal from 'vue-cal';
import Multiselect from 'vue-multiselect';
import 'vue-cal/dist/vuecal.css';
import { BRow, BCol, BCard, BCardHeader, BCardBody, BInputGroup, BFormInput, BInputGroupAppend, BInputGroupPrepend, BButton, BTooltip, BListGroup, BListGroupItem, BPagination, BModal, BFormSelect, BFormCheckbox, BFormDatepicker, BFormTimepicker, BFormTextarea, BDropdown, BDropdownItem } from 'bootstrap-vue';

export default {
  name: 'ClicCalendar',
  components: { VueCal, Multiselect, BRow, BCol, BCard, BCardHeader, BCardBody, BInputGroup, BFormInput, BInputGroupAppend, BInputGroupPrepend, BButton, BTooltip, BListGroup, BListGroupItem, BPagination, BModal, BFormSelect, BFormCheckbox, BFormDatepicker, BFormTimepicker, BFormTextarea, BDropdown, BDropdownItem },
  mixins: [ComponentMixin],
  data() {
    return {
      public: {
        setEvents: this.setEvents,
        abrirEvento: this.abrirEvento,
        getSelectedEvent: this.getSelectedEvent,
        concluirAgenda: this.concluirAgenda,
        marcarComoPerda: this.marcarComoPerda,
        marcarComoGanho: this.marcarComoGanho,
        marcarComoCancelado: this.marcarComoCancelado,
        marcarComoConcluido: this.marcarComoConcluido,
        marcarComoPendente: this.marcarComoPendente,
        fecharModal: this.hideModalsClearVariables,
        disableCompletedEvents: true,
        selectedEvent: this.selectedEvent
      },

      operationTypes: ["following", "serie", "single"],
      events: [],
      recurrentConfig: {},
      selectedEvent: {},
      actualViewForCalendar: {},

      messageDisabledCompletedEvents: "Mostrar todos",
      disableCompletedEvents: true,
      isEditingEvent: false,
      isRecurrent: false,

      colorOptions: [
        { value: 'clic', text: 'Clic' },
        { value: 'black', text: 'Preto' },
        { value: 'green', text: 'Verde' },
        { value: 'blue', text: 'Azul' },
        { value: 'pink', text: 'Rosa' },
        { value: 'yellow', text: 'Amarelo' },
        { value: 'purple', text: 'Roxo' },
        { value: 'red', text: 'Vermelho' },
        { value: 'gray', text: 'Cinza' },
        { value: 'cyan', text: 'Ciano' },
        { value: 'brown', text: 'Marrom' },
        { value: 'indigo', text: 'Índigo' },
        { value: 'olive', text: 'Oliva' },
      ],
      recurrentIntervals: [
        { value: 'd', text: 'Dia(s)' },
        { value: 's', text: 'Semana(s)' },
        { value: 'm', text: 'Mês(s)' }
      ],

      subdominio: this.$host.subdominio,

      selectedReasonForLoss: { value: 'NAO_ATENDE', text: 'Cliente não atende' },

      searchQuery: "",
      currentPage: 1,
    };
  },
  created() {
    this.locale = this.getLocale();
    this.timeZone = this.getTimezone();
    this.setEvents();

  },
  mounted() {
  },
  watch: {
    selectedEvent: {
      handler(newVal) {
        console.log("watch")
        this.public.selectedEvent = newVal;
      },
      deep: true
    },
    disableCompletedEvents: {
      handler(newVal) {
        this.public.disableCompletedEvents = newVal;
      },
      deep: true
    }
  },
  computed: {
    showEventActions() {
      if (!this.isEditingEvent) { return false }
      return !this.situationsOfConcludedEvents.includes(this.getSelectedEventSituation());
    },
    filteredEvents() {
      let events = Array.isArray(this.events) ? this.events : [];

      if (this.searchQuery) {
        events = events.filter(event =>
          event.title.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }

      const now = new Date();
      return [...events]
        .sort((a, b) => new Date(a.start) - new Date(b.start))
        // .filter((evnt) => new Date(evnt.start) > now);
    },
    totalRows() {
      return this.filteredEvents.length;
    },
    paginatedEvents() {
      const start = (this.currentPage - 1) * this.registerPerPageList;
      const end = this.currentPage * this.registerPerPageList;
      const paginated = this.filteredEvents.slice(start, end);

      return paginated.reduce((groups, event) => {
        const day = this.formatDate(new Date(event.start));
        if (!groups[day]) {
          groups[day] = [];
        }
        groups[day].push(event);
        return groups;
      }, {});
    }
  },
  methods: {

    getLocale() {
      const frameLanguage = this.$storage.getIdioma().toLowerCase();
      switch (frameLanguage) {
        case "pt": return "pt-br";
        default: return frameLanguage
      }
    },
    getTimezone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone; 
    },
    onEventClick($event) {
      if ($event) {
        this.defineInputsModalCreate($event)
      }

      if (this.lodash.has(this.cp, 'events.onEventClick')) {
        this._execEvent('onEventClick', { $event });
      }
    },
    onEventDblclick($event) {
      if ($event) {
        this.defineInputsModalCreate($event)
      }

      if (this.lodash.has(this.cp, 'events.onEventDblclick')) {
        this._execEvent('onEventDblclick', { $event });
      }
    },
    onEventCreate($event) {
      if (this.lodash.has(this.cp, 'events.onEventCreate')) {
        this._execEvent('onEventCreate', { $event });
      }
    },
    onEventFocus($event) {
      if ($event) {
        this.defineInputsModalEdit($event)
      }

      if (this.lodash.has(this.cp, 'events.onEventFocus')) {
        this._execEvent('onEventFocus', { $event });
      }
    },
    onEventDelete($event) {
      if (this.lodash.has(this.cp, 'events.onEventDelete')) {
        this._execEvent('onEventDelete', { $event });
      }
    },
    onViewChange($view) {
      this.actualViewForCalendar = $view
      this.setEvents()
      if (this.lodash.has(this.cp, 'events.onViewChange')) {
        this._execEvent('onViewChange', { $view });
      }
    },



    //-------Públicos-------
    setEvents(data) {
      if (data) {
        this.events = this.normalizeEvents(data)
      } else {
        this.getEvents().then((events) => {
          this.events = this.normalizeEvents(events)
        })
      }
    },

    normalizeEvents(events) {
      if (!Array.isArray(events)) { return events }
      return events.map(event => {
        if (event && event.start) { event.start = new Date(event.start) }
        if (event && event.end) { event.end = new Date(event.end) }
        return event
      });
    },

    abrirEvento(id) {
      return new Promise((resolve) => {
        if (!id) {
          resolve(console.log("Informe o id do evento para abrir o modal"));
          return;
        }

        const localEvent = this.events.find(event => event._id === id);
        if (localEvent) {
          this.defineInputsModalEdit(localEvent);
          resolve(localEvent);
          return;
        }

        this.getEvents({ id, disableCompletedEvents: false }).then((data) => {
          let events = Array.isArray(data) ? data : [data];
          const found = this.normalizeEvents(events).find(event => event && event._id === id);

          if (found) {
            this.defineInputsModalEdit(found);
            resolve(found);
          } else {
            this.$notificacao({ text: "Evento não encontrado", type: 'danger' });
            resolve();
          }
        });
      });
    },

    hideModalsClearVariables() {
      this.$bvModal.hide('delete-recurrents-modal')
      this.$bvModal.hide('delete-following-modal')
      this.$bvModal.hide('edit-following-modal')
      this.$bvModal.hide('edit-recurrent-modal')
      this.$bvModal.hide('create-event-modal')
      this.$bvModal.hide('delete-event-modal')
      this.$bvModal.hide('edit-serie-modal')
      this.$bvModal.hide('lost-sell-modal')
      this.clearPersonalizedInputs();
      this.recurrentConfig = {}
      this.isRecurrent = false;
    },

    handleDisableCompleted() {
      try {
        if (this.disableCompletedEvents) {
          this.disableCompletedEvents = false
          this.messageDisabledCompletedEvents = "Ocultar concluídos"
        } else {
          this.disableCompletedEvents = true
          this.messageDisabledCompletedEvents = "Mostrar todos"
        }
        this.setEvents()

      } catch (error) {
        console.log(error);
      }
    },

    concluirAgenda(evento, situation, editType = 'single') {
      return new Promise(async (resolve, reject) => {
        try {

          let idsToReply = []

          if (!evento || !evento._id) {
            resolve(console.log("Informe o evento para concluir a agenda"));
          }

          if (situation && !this.situationsOfConcludedEvents.some(v => editType === v)) {
            resolve(console.log(`Situação inválido. Opções disponíveis: ${this.situationsOfConcludedEvents.toString()}`));
          }

          if (editType && !this.operationTypes.some(v => editType === v)) {
            resolve(console.log(`Tipo de operação inválido. Opções disponíveis: ${this.operationTypes.toString()}`));
          }

          if (editType !== 'single') {
            let eventos = await this.getEvents({
              id: evento._id,
              editType:
                editType == "following" ? 'following' :
                  editType == "serie" ? "serie" :
                    null
            });

            if (!Array.isArray(eventos)) { eventos = [eventos] }

            idsToReply = eventos.filter(event => event._id !== idEvento);
            idsToReply = idsToReply.map(event => ({ _id: event._id }));
          }

          const diffMinutes = this.getTimeDifference();
          if (diffMinutes <= 0) { return (this.$notificacao({ text: "Não foi possível concluit a agenda. A hora de início deve ser menor que a hora do término do evento", type: 'danger' })); }

          const formattedObject = {
            "slot": { ...this.getPersonalizedInputs() },
            "start": this.generateDate(evento.startDate, evento.startTime),
            "end": this.generateDate(evento.endDate, evento.endTime),
          };

          const { startDate, endDate, startTime, endTime, ...event } = this.lodash.merge(evento, formattedObject)

          const foundSituation = { ...this.situations.find(s => s.value === situation) };
          if (situation == "PERDA") { foundSituation.motivoPerda = this.selectedReasonForLoss }
          event.situacao = foundSituation

          await this.putEvent(event, idsToReply)
          this.setEvents()
          resolve()

        } catch (error) {
          reject(error);
        }
      });
    },

    marcarComoPerda(event) {
      this.selectedEvent = event
      if (this.selectedEvent) {
        this.$bvModal.show('lost-sell-modal');
      }
    },

    confirmarPerda() {
      return this.concluirAgenda(this.selectedEvent, 'PERDA', 'single')
        .then(() => { this.hideModalsClearVariables() });
    },

    marcarComoGanho(event) {
      this.selectedEvent = event
      this.concluirAgenda(event, "GANHO");
    },

    marcarComoCancelado(event) {
      this.selectedEvent = event
      this.concluirAgenda(event, "CANCELADO");
    },

    marcarComoConcluido(event) {
      this.selectedEvent = event
      this.concluirAgenda(event, "CONCLUIDO");
    },

    marcarComoPendente(event) {
      this.selectedEvent = event
      this.concluirAgenda(event, "PENDENTE")
    },



    //-------Privados------------

    defineInputsModalCreate(event) {
      const date = new Date(event);
      const formattedDate = this.formatDate(date);

      let roundedMinutes = Math.round(date.getMinutes() / 5) * 5;
      if (roundedMinutes === 60) { roundedMinutes = 55 }

      const minutes = String(roundedMinutes).padStart(2, '0');
      const hourStart = String(date.getHours()).padStart(2, '0');
      const hourEnd = String(date.getHours() + 1).padStart(2, '0');

      this.selectedEvent = {
        startDate: formattedDate,
        endDate: formattedDate,
        startTime: `${hourStart}:${minutes}`,
        endTime: `${hourEnd}:${minutes}`,
        title: "Novo Evento",
        class: 'clic',
      };

      this.isEditingEvent = false;
      this.recurrentConfig.endDate = this.selectedEvent.startDate;

      this.clearPersonalizedInputs();
      this.$bvModal.show('create-event-modal');
    },

    defineObjectCreateEvent() {
      const selectedEvent = this.selectedEvent;
      const diffMinutes = this.getTimeDifference();

      if (diffMinutes <= 0) {
        return (this.$notificacao({ text: "Não foi possível criar esse evento. A hora de início deve ser menor que a hora do término do evento", type: 'danger' }))
      }

      if (this.isRecurrent && (!this.recurrentConfig.interval || !this.recurrentConfig.period)) {
        return (this.$notificacao({ text: "Preencha corretamente as configurações de recorrência", type: 'danger' }))
      }

      const event = {
        "slot": { ...this.getPersonalizedInputs() },
        "start": this.generateDate(selectedEvent.startDate, selectedEvent.startTime),
        "end": this.generateDate(selectedEvent.endDate, selectedEvent.endTime),
        "title": selectedEvent.title,
        "class": selectedEvent.class,
        "situacao": { value: 'PENDENTE', text: 'Pendente' }
      }

      this.postEvent(event, this.isRecurrent ? this.recurrentConfig : null).then(() => {
        // Mantém o modal aberto ao salvar; o usuário fecha pelo botão "Fechar".
        this.setEvents()
      })

    },

    defineInputsModalEdit(event) {

      const formattedObject = {
        startDate: this.formatDate(new Date(event.start)),
        endDate: this.formatDate(new Date(event.end)),
        startTime: this.formatTime(new Date(event.start)),
        endTime: this.formatTime(new Date(event.end))
      };
      this.selectedEvent = { ...this.lodash.cloneDeep(event), ...formattedObject };
      this.isEditingEvent = true;

      this.$nextTick(() => { this.definePersonalizedInputs(event.slot); });
      this.$bvModal.show('create-event-modal');
    },

    defineObjectEditEvent(editType) {
      return new Promise(async (resolve, reject) => {
        const selectedEvent = this.selectedEvent;
        const diffMinutes = this.getTimeDifference();
        let replyForIds = []

        if (selectedEvent._id) {

          if (editType && !this.operationTypes.some(v => editType === v)) {
            resolve(console.log(`Tipo de operação inválido. Opções disponíveis: ${this.operationTypes.toString()}`));
          }

          if (diffMinutes <= 0) {
            return (this.$notificacao({ text: "Não foi possível editar esse evento. A hora de início deve ser menor que a hora do término do evento", type: 'danger' }));
          }

          const formattedObject = {
            "slot": { ...this.getPersonalizedInputs() },
            "start": this.generateDate(selectedEvent.startDate, selectedEvent.startTime),
            "end": this.generateDate(selectedEvent.endDate, selectedEvent.endTime),
          };

          const { startDate, endDate, startTime, endTime, ...event } = this.lodash.merge(selectedEvent, formattedObject)

          if (editType == 'serie') {
            replyForIds = await this.getSerieEvents(selectedEvent, 'serie');
          } else if (editType == 'following') {
            replyForIds = await this.getSerieEvents(selectedEvent, 'following');
          }

          this.putEvent(event, replyForIds).then(() => {
            // Mantém o modal de edição aberto ao salvar; fecha apenas os modais de
            // confirmação de recorrência (caso estejam abertos por cima).
            this.$bvModal.hide('edit-serie-modal')
            this.$bvModal.hide('edit-following-modal')
            this.setEvents()
          })
        }
      });
    },

    defineInputsModalRecurrent() {
      return new Promise(async (resolve, reject) => {
        const params = { "id": this.selectedEvent.recurrentId }
        this.recurrentConfig = await this.getRecurrent(params);

        this.$bvModal.hide('create-event-modal');
        this.$bvModal.show('edit-recurrent-modal');

        this.recurrentConfig.newStartDate = this.recurrentConfig.startDate;
        this.recurrentConfig.newEndDate = this.recurrentConfig.endDate;

        resolve();
      });
    },

    defineObjectEditRecurrent() {
      return new Promise(async (resolve, reject) => {
        const selectedEvent = this.selectedEvent;
        const recurrent = this.recurrentConfig;

        await this.defineObjectDeleteEvent('serie');
        await this.postEvent(selectedEvent, recurrent);
        await this.postRecurrent(recurrent);
        this.hideModalsClearVariables();
        this.setEvents();

        resolve();

      });
    },

    defineObjectDeleteEvent(deleteType) {
      return new Promise(async (resolve, reject) => {

        let ids = []
        const selectedEvent = this.selectedEvent;

        if (deleteType && !this.operationTypes.some(v => deleteType === v)) {
          resolve(console.log(`Tipo de operação inválido. Opções disponíveis: ${this.operationTypes.toString()}`));
        }

        if (deleteType == 'single') {
          await this.deleteEvent()
          resolve()

        } else if (deleteType == 'serie') {
          ids = await this.getSerieEvents(selectedEvent, 'serie');

        } else if (deleteType == 'following') {
          ids = await this.getSerieEvents(selectedEvent, 'following');
        }

        ids = ids.map(event => ({ _id: event._id }));
        await this.deleteEvent(ids);
        resolve();
      })
    },

    getSerieEvents(selectedEvent, getType) {
      return new Promise(async (resolve, reject) => {

        if (getType && !this.operationTypes.some(v => getType === v)) {
          resolve(console.log(`Tipo de operação inválido. Opções disponíveis: ${this.operationTypes.toString()}`));
        }

        const events = await this.getEvents({
          id: selectedEvent._id,
          searchType: getType == "following" ? "following" : "serie"
        })

        const diffStart = new Date(selectedEvent.start) - new Date(selectedEvent.previousDate.start);
        const diffEnd = new Date(selectedEvent.end) - new Date(selectedEvent.previousDate.end);

        let replyForIds = events.map(evnt => {
          const evntStartDateTime = new Date(evnt.previousDate.start);
          const evntEndDateTime = new Date(evnt.previousDate.end);
          const newStartDateTime = new Date(evntStartDateTime.getTime() + diffStart);
          const newEndDateTime = new Date(evntEndDateTime.getTime() + diffEnd);

          const createEvent = (id, start, end, previousDate) => ({
            _id: id,
            start: this.generateDate(this.formatDate(start), selectedEvent.startTime),
            end: this.generateDate(this.formatDate(end), selectedEvent.endTime),
            previousDate: previousDate
          });

          return createEvent(evnt._id, newStartDateTime, newEndDateTime, evnt.previousDate);

        }).filter(event => event !== undefined);

        resolve(replyForIds)
      });
    },


    //------Requisições------------

    getEvents(params = {}) {
      return new Promise((resolve, reject) => {

        let startDate = new Date()
        let endDate = new Date()

        if (!this.actualViewForCalendar.startDate && !this.actualViewForCalendar.endDate) {
          let days = this.hideCalendar ? 90 : 30
          const today = new Date();
          startDate = new Date(today);
          endDate = new Date(today);
          startDate.setDate(today.getDate() - days);
          endDate.setDate(today.getDate() + days);

        } else {
          startDate = new Date(this.actualViewForCalendar.startDate);
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date(this.actualViewForCalendar.endDate);
          endDate.setHours(0, 0, 0, 0);

        }

        let options = {
          method: 'GET',
          url: `https://${this.subdominio}.clictecnologia.com.br/api/agenda`,
          headers: { "content-type": "application/json" },
          params: {
            ...params,
            disableCompletedEvents: params.disableCompletedEvents ?? this.disableCompletedEvents,
            startDate: startDate,
            endDate: endDate
          }
        };

        this.$axios.request(options).then((response) => {
          if (response.data.metricas) { this.metrics = response.data.metricas }
          resolve(response.data.dados)
        }).catch((e) => {
          resolve({ error: e })
        });
      });
    },

    postEvent(event, recurrent) {
      return new Promise(async (resolve, reject) => {

        let options = {
          method: 'POST',
          url: `https://${this.subdominio}.clictecnologia.com.br/api/agenda`,
          headers: { "content-type": "application/json" },
          data: {
            evento: event,
          }
        };

        if (recurrent) {
          if (!recurrent._id) {
            recurrent = await this.postRecurrent(recurrent);
          }
          options.data.recorrencia = recurrent
        }

        this.$axios.request(options).then((response) => {
          resolve();
        }).catch((e) => {
          resolve({ error: e });
        });
      });
    },

    putEvent(event, replyForIds = []) {
      return new Promise((resolve, reject) => {

        let options = {
          method: 'PUT',
          url: `https://${this.subdominio}.clictecnologia.com.br/api/agenda`,
          headers: { "content-type": "application/json" },
          data: {
            evento: event,
            eventosRelacionados: replyForIds
          }
        };

        this.$axios.request(options).then((response) => {
          resolve()
        }).catch((e) => {
          resolve({ error: e })
        });
      });
    },

    deleteEvent(idsToDelete) {
      return new Promise((resolve, reject) => {
        if (!idsToDelete) { idsToDelete = [{ "_id": this.selectedEvent._id }] }

        let options = {
          method: 'DELETE',
          url: `https://${this.subdominio}.clictecnologia.com.br/api/agenda`,
          headers: { "content-type": "application/json" },
          data: {
            "ids": idsToDelete
          }
        };

        this.$axios.request(options).then((response) => {
          if (response.data.codigo == 1) {
            this.hideModalsClearVariables();
            this.setEvents();
            resolve();
          } else {
            this.$notificacao({ text: response.data.mensagem, type: 'danger' });
            resolve();
          }
        }).catch((e) => {
          resolve({ error: e })
        });
      });
    },

    getRecurrent(params) {
      return new Promise((resolve, reject) => {
        let options = {
          method: 'GET',
          url: `https://${this.subdominio}.clictecnologia.com.br/api/recorrencia`,
          headers: { "content-type": "application/json" },
          params: { ...params }
        };

        this.$axios.request(options).then((response) => {
          resolve(response.data.dados)
        }).catch((e) => {
          resolve({ error: e })
        });
      });
    },

    postRecurrent(recurrent) {

      if (!recurrent.startDate) {
        recurrent.startDate = this.selectedEvent.startDate
      }

      if (recurrent.newStartDate && recurrent.newEndDate) {
        recurrent.startDate = recurrent.newStartDate;
        recurrent.endDate = recurrent.newEndDate;
        delete recurrent.newStartDate;
        delete recurrent.newEndDate;
      }

      return new Promise((resolve, reject) => {
        let options = {
          method: 'POST',
          url: `https://${this.subdominio}.clictecnologia.com.br/api/recorrencia`,
          headers: { "content-type": "application/json" },
          data: {
            ...recurrent,
          }
        };

        this.$axios.request(options).then((response) => {
          const recurrent = response.data?.dados?.recorrencia ?? null;
          if (recurrent) {
            resolve(recurrent);
          } else {
            resolve();
          }
        }).catch((e) => {
          resolve({ error: e })
        });
      });
    },

    deleteRecurrent(recurrentId) {
      return new Promise((resolve, reject) => {
        let options = {
          method: 'DELETE',
          url: `https://${this.subdominio}.clictecnologia.com.br/api/recorrencia`,
          headers: { "content-type": "application/json" },
          data: {
            "id": recurrentId
          }
        };

        this.$axios.request(options).then((response) => {
          resolve()
        }).catch((e) => {
          resolve({ error: e })
        });
      });
    },


    //-------Funções auxiliares--------

    generateDate(date, time) {
      const timeParts = time.split(':');
      const dateParts = date.split('-');
      let eventDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

      eventDate.setHours(parseInt(timeParts[0], 10));
      eventDate.setMinutes(parseInt(timeParts[1], 10));
      eventDate.setSeconds(0);

      return eventDate
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;

      return formattedDate
    },
    formatTime(date) {
      const formattedTime = new Date(date).toLocaleTimeString(this.locale, { timeZone: this.timeZone, hour: '2-digit', minute: '2-digit', hour12: false })

      return formattedTime
    },
    getTimeDifference() {
      const startDate = this.generateDate(this.selectedEvent.startDate, this.selectedEvent.startTime)
      const endDate = this.generateDate(this.selectedEvent.endDate, this.selectedEvent.endTime)
      const diffMinutes = (endDate - startDate) / (1000 * 60);
      return diffMinutes
    },
    formatDateForList(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const localDate = new Date(date + 'T00:00:00');
      return localDate.toLocaleDateString(this.locale, options);
    },
    formatDayOfWeek(date) {
      const options = { weekday: 'long' };
      return new Date(date + 'T00:00:00').toLocaleDateString(this.locale, options);
    },
    formatTimeForList(datetime, startDatetime) {
      const time = this.formatTime(new Date(datetime));
      if (startDatetime) {
        const startDate = new Date(startDatetime);
        const endDate = new Date(datetime);
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays > 1 ? `${time} +${diffDays - 1} Dia(s)` : time;
      }
      return time;
    },


    //---------Slot---------

    getSlotAcao() {
      let row = this.$getSlot('acao');
      let filteredRow = row.filter(element => element.component === 'ClicDropdown');
      return filteredRow;
    },
    getSlotModal() {
      let row = [{
        "id": "containerModalClicCalendar",
        "component": "ClicRow",
        "props": { "visible": true, "slot": "modal" },
        "events": {},
        "childrens": []
      }]
      row[0].childrens = this.$getSlot('modal');
      return row

    },
    getPersonalizedInputs() {
      let comp = this.$getComponents()
      if (comp.containerModalClicCalendar) {
        return comp.containerModalClicCalendar.getFormValuesAsJson();
      }
    },
    definePersonalizedInputs(objeto) {
      let comp = this.$getComponents()
      if (comp.containerModalClicCalendar) {
        comp.containerModalClicCalendar.setFormValues(objeto);
      }
    },
    clearPersonalizedInputs() {
      let comp = this.$getComponents()
      if (comp.containerModalClicCalendar) {
        comp.containerModalClicCalendar.clearForm();
      }
    },
    getSelectedEvent() {
      return this.selectedEvent;
    },
    getSelectedEventSituation() {
      return this.selectedEvent?.situacao?.value ?? "CONCLUIDO"
    },
    getSituationIcon(value) {
      let filteredSituations = this.situations.filter((situation) => situation.value == value);
      if (filteredSituations[0]?.icon) {
        return filteredSituations[0].icon
      }
      return ("md-done-round")
    }

  }

};
</script>

<style>
/* ============================================================
   ClicCalendar — refinamento visual
   ============================================================ */

/* --- Card "Próximos Eventos" --- */
.clic-calendar-list-card {
  border: 1px solid #eef0f4;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(20, 23, 28, 0.06);
  overflow: hidden;
}

.clic-calendar-list-card .card-body {
  padding: 1rem;
}

.clic-calendar-list-title {
  background: #ffffff;
  border-bottom: 1px solid #f0f1f5;
  padding: 0.9rem 1rem;
}

.clic-calendar-list-title h5 {
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #2b2f36;
}

/* Cabeçalho de cada dia na lista */
.clic-calendar-day-group {
  margin-bottom: 0.85rem;
}

.clic-calendar-day-header {
  padding: 0.35rem 0.15rem 0.5rem;
  margin-bottom: 0.15rem;
  border-bottom: 1px solid #f0f1f5;
}

.clic-calendar-day-date {
  font-weight: 600;
  font-size: 0.9rem;
  color: #2b2f36;
  text-transform: capitalize;
}

.clic-calendar-day-weekday {
  font-size: 0.78rem;
  color: #9aa0a8;
  text-transform: capitalize;
}

/* Item de evento na lista */
.clic-calendar-list-card .clic-calendar-event-item {
  position: relative;
  cursor: pointer;
  border: 1px solid #f0f1f5;
  border-radius: 10px;
  padding: 0.6rem 0.75rem 0.6rem 1rem;
  margin: 0.4rem 0;
  background: #ffffff !important;
  color: #2b2f36 !important;
  gap: 0.6rem;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.clic-calendar-list-card .clic-calendar-event-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(20, 23, 28, 0.08);
  border-color: #e3e6ec;
}

/* Barrinha de cor à esquerda, herdando a cor do evento */
.clic-calendar-event-accent {
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 4px;
  border-radius: 4px;
  background-color: currentColor;
  opacity: 0.9;
}

.clic-calendar-event-icon {
  display: inline-flex;
  align-items: center;
  color: #6b7280;
  font-size: 1.05rem;
  flex: 0 0 auto;
}

.clic-calendar-event-title {
  font-weight: 600;
  font-size: 0.88rem;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clic-calendar-event-times {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex: 0 0 auto;
  font-size: 0.78rem;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}

.clic-calendar-event-sep {
  color: #c2c7d0;
}

/* --- vue-cal: refinamento geral --- */
.vuecal {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(20, 23, 28, 0.06);
  border: 1px solid #eef0f4;
  font-family: inherit;
}

.vuecal__title-bar {
  background: #ffffff;
  border-bottom: 1px solid #f0f1f5;
  min-height: 3rem;
  font-weight: 600;
  color: #2b2f36;
}

.vuecal__menu {
  background: #ffffff;
  border-bottom: 1px solid #f0f1f5;
}

.vuecal__menu .vuecal__view-btn {
  color: #6b7280;
  font-weight: 500;
  border-bottom: 2px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.vuecal__menu .vuecal__view-btn:hover {
  color: #f68b2a;
  background: rgba(246, 139, 42, 0.06);
}

.vuecal__menu .vuecal__view-btn--active {
  color: #f68b2a;
  border-bottom-color: #f68b2a;
  background: rgba(246, 139, 42, 0.08);
}

.vuecal__arrow {
  color: #9aa0a8;
  transition: color 0.15s ease;
}

.vuecal__arrow:hover {
  color: #f68b2a;
}

.vuecal__cell {
  transition: background 0.15s ease;
}

.vuecal__cell:hover {
  background: rgba(246, 139, 42, 0.04);
}

.vuecal__cell--today,
.vuecal__cell--current {
  background: rgba(246, 139, 42, 0.08);
}

.vuecal__cell--selected {
  background: rgba(246, 139, 42, 0.14);
}

.vuecal__cell--selected:before {
  border-color: rgba(246, 139, 42, 0.5);
}

.vuecal__cell-date {
  font-size: 0.8rem;
  color: #4b5158;
}

.vuecal__now-line {
  color: #f68b2a;
}

/* Eventos dentro do calendário */
.vuecal__event {
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(20, 23, 28, 0.12);
  padding: 2px 6px;
  font-size: 0.8rem;
  line-height: 1.25;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.vuecal__event:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(20, 23, 28, 0.2);
  z-index: 2;
}

.vuecal__event-title {
  font-weight: 600;
}

.vuecal__event-time {
  opacity: 0.85;
  font-size: 0.72rem;
}

/* Contador de eventos (month/year view) */
.vuecal__cell-events-count {
  background: #f68b2a;
  box-shadow: 0 1px 3px rgba(246, 139, 42, 0.4);
}

@media (max-width: 767.98px) {
  .clic-calendar-modal-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .clic-calendar-modal-footer .btn,
  .clic-calendar-modal-footer .btn-group,
  .clic-calendar-modal-footer .dropdown {
    width: 100%;
    margin: 0.25rem 0;
  }

  .clic-calendar-modal-footer .btn-group,
  .clic-calendar-modal-footer .dropdown {
    display: flex;
  }

  .clic-calendar-modal-footer .btn-group .btn,
  .clic-calendar-modal-footer .dropdown .btn {
    margin: 0;
  }
}

.vuecal--month-view .vuecal__cell {
  min-height: 50px;
}

.vuecal--month-view .vuecal__cell-content {
  justify-content: flex-start;
  height: 100%;
  align-items: flex-end;
}

.vuecal--month-view .vuecal__cell-date {
  padding: 4px;
}

.vuecal--month-view .vuecal__no-event {
  display: none;
}


.vuecal__special-hours {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;

  em {
    font-size: 0.9em;
    color: #999;
  }
}


.color-block {
  width: 20px;
  /* Defina a largura do bloco de cor conforme necessário */
  height: 20px;
  /* Defina a altura do bloco de cor conforme necessário */
  background-color: #ffffff;
  /* Defina a cor desejada */
  margin-right: 8px;
  /* Espaço entre o bloco de cor e o select */
  border-radius: 3px;
  /* Opcional: arredondar os cantos */
}

.clic {
  background-color: #f68b2a;
  color: #ffffff;
}

.black {
  background-color: #000000;
  color: #ffffff;
}

.green {
  background-color: #01ad15;
  color: #eaeaea;
}

.blue {
  background-color: #d6e4fa;
  color: #0061ff;
}

.pink {
  background-color: #fcf0ff;
  color: #cf1fff;
}

.purple {
  background-color: #5500ff;
  color: #ffffff;
}

.red {
  background-color: #eb0000;
  color: #ffffff;
}

.gray {
  background-color: #f5f5f5;
  color: #808080;
}

.cyan {
  background-color: #077070;
  color: #ffffff;
}

.yellow {
  background-color: #ffffcc;
  color: #cccc33;
}

.brown {
  background-color: #f4a460;
  color: #fff8f3;
}

.indigo {
  background-color: #4b0082;
  color: #f9f0ff;
}

.olive {
  background-color: #808000;
  color: #eeeeee;
}




.closed {
  background:
    #fff7f0 repeating-linear-gradient(-45deg,
      rgba(255, 162, 87, 0.25),
      rgba(255, 162, 87, 0.25) 5px,
      rgba(255, 255, 255, 0) 5px,
      rgba(255, 255, 255, 0) 15px);
  color: #f6984c;
}
</style>
